module.exports = __webpack_public_path__ + "media/images/proof_links/telegram-360845a3a8adee733b38dc2904d87270.svg";